import { Currency } from 'hydra-data-types';

// Pain (Relio)
export const referralComparisonPain = '/images/pain/referralComparison.png';
export const painPathways = '/images/pain/painPathways.png';
export const hypnosisLongHistory = '/images/pain/hypnosisLongHistory.png';
export const guidedAudio = '/images/pain/guidedAudio.png';
export const progressToCalm = '/images/pain/progressToCalm.png';
export const resultsDatePain = '/images/pain/resultsDate.png';
export const addressMotivation = '/images/pain/addressMotivation.png';
export const percentageImproveByResultsDate = '/images/pain/percentageImproveByResultsDate.png';
export const maintenanceExperiencePain = '/images/pain/maintenanceExperiencePain.png';
export const moneyBackGuaranteePain = '/images/pain/moneyBackGuaranteePain.png';
export const backBrainTherapyWorksEdu = '/images/pain/backBrainTherapyWorksEdu.png';
export const overprotectivePainSystemEdu = '/images/pain/overprotectivePainSystemEdu.png';
export const painPathwaysEdu = '/images/pain/painPathwaysEdu.png';
export const systemActivationPainEdu = '/images/pain/systemActivationPainEdu.png';
export const guidedAudioPathways = '/images/pain/guidedAudioPathways.png';
export const progressToCalmPathways = '/images/pain/progressToCalmPathways.png';

// Shared
export const drGary = '/images/GaryElkins.png';
export const storeReviewRow = '/images/storeReviewRow.png';
export const doctor = '/images/doctor.png';
export const certificate = '/images/certificate.png';
export const moneyBackGuarantee = '/images/moneyBackGuarantee.png';

// Nerva
export const pattyG = '/images/pattyG.jpg';
export const simonePeters = '/images/simonePeters.png';
export const simonePeters2024 = '/images/simonePeters2024.png';
export const simonePetersLarge = '/images/simonePetersLarge.png';
export const gutBrainConnection = '/images/gutBrainConnection.jpg';
export const gutBrainTick = '/images/gutBrainTick.png';
export const ibsResultsDate = '/images/ibsResultsDate.png';
export const maintenanceProgramPreview = '/images/maintenanceProgramPreview.png';
export const mindBody = '/images/mindBody.png';
export const improvementStatsSocialProof = '/images/improvementStatsSocialProof.png';
export const referralComparisonNerva = '/images/referralComparisonNerva.png';
export const brainGut = '/images/brainGut.svg';
export const brainGutRealistic = '/images/brainGut.jpg';
export const brainGutLine = '/images/brainGutLine.png';
export const downloadApp = '/images/downloadApp.png';
export const examplePatients = '/images/examplePatients.png';
export const womanLounging = '/images/womanLounging.png';
export const nervaHolding = '/images/nervaHolding.png';
export const drPetersCredentials = '/images/drPetersCredentials.png';
export const hypnoFodmapChart = '/images/hypnoFodmapChart.png';
export const hypnoFodmapChartWithMonashLogo = '/images/hypnoFodmapChartWithMonashLogo.jpg';
export const drPetersWithMonashClinicLogos = '/images/drPetersWithMonashClinicLogos.png';
export const fruit = '/images/fruit.jpg';
export const visceralHypnersensitivity = '/images/visceralHypnersensitivity.png';
export const monashMindGutLogos = '/images/logos/monashMindGutLogos.png';
export const acceptReferral = '/images/acceptReferral.jpg';
export const biometrics = '/images/biometrics.png';
export const referralChart = '/images/referralChart.png';
export const drPetersWithMonashClinicLogosTransparent =
  '/images/drPetersWithMonashClinicLogosTransparent.png';
export const brainGutCommunication = '/images/brainGutCommunication.png';
export const educationUnderlyingReasonImage = '/images/educationUnderlyingReason.png';
export const recommendedByClinicalGuidelinesLogos =
  '/images/recommendedByClinicalGuidelinesLogos.png';
export const quotationWhite = '/images/quotes-white.svg';
export const nervaRatings = '/images/nervaRatings.png';
export const symptomsNotInYourHead = '/images/symptomsNotInYourHead.svg';
export const gutOnHighAlert = '/images/gutOnHighAlert.svg';
export const nervaDailyRoutine = '/images/dailyRoutine.png';
export const weeklyCards = '/images/weeklyCards.png';
export const relaxedWomanHeadphones = '/images/relaxedWomanHeadphones.png';
export const medicareCardSample = '/images/medicareCardSample.avif';
export const brainGutArrows = '/images/brainGutArrows.webp';
export const sensitivityDial = '/images/sensitivityDial.svg';
export const hipaaLogo = '/images/logos/hipaa.png';
export const soc2Logo = '/images/logos/soc2.png';

// Meno
export const fran = '/images/fran.jpg';
export const drElkinsCredentialsVertical = '/images/drElkinsCredentialsVertical.png';
export const hormoneLevelGraph = '/images/hormoneLevelGraph.png';
export const safeTemperatureGraph = '/images/safeTemperatureGraph.png';
export const hotFlashManagementGraph = '/images/hotFlashManagementGraph.png';
export const hypnoMentalHealthGraph = '/images/hypnoMentalHealthGraph.png';
export const hypothalamus = '/images/hypothalamusSleepFocus.png';
export const franTestimonial = '/images/franTestimonial.png';
export const michelleTestimonial = '/images/michelleTestimonial.png';
export const hypnoTrialFindings = '/images/hypnoTrialFindings.png';
export const menoProgram = '/images/menoProgram.svg';
export const menoOngoingSupport = '/images/menoOngoingSupport.png';
export const menoPhysicalReaction = '/images/menoPhysicalReaction.png';
export const menoScreenshot = '/images/menoScreenshot.png';
export const menoMaintenanceScreenshot = '/images/menoMaintenanceScreenshot.png';

// Quit
export const linda = '/images/linda.jpg';
export const quitTodayScreen = '/images/quitTodayScreen.svg';
export const quitReinforcementScreen = '/images/quitReinforcementScreen.png';
export const quitBrain = '/images/quitBrain.png';
export const quitBrain2 = '/images/quitBrain2.png';
export const quitProgram7DayTrial = '/images/quitProgram7DayTrial.png';
export const quitEducationHealing = '/images/quitEducationHealing.jpg';
export const quitEducationQuitAttempts = '/images/quitEducationQuitAttempts.jpg';
export const quitEducationTreatments = '/images/quitEducationTreatments.jpg';
export const quitEducationWithdrawalSymptoms = '/images/quitEducationWithdrawalSymptoms.jpg';
export const quitSessionAndSignupScreenshots = '/images/quitSessionAndSignupScreenshots.png';
export const peopleRidingBicycle = '/images/peopleRidingBicycle.jpg';
export const emailReferralIllustration = '/images/emailReferralIllustration.jpg';

export const Flags: Record<Currency, string> = {
  [Currency.AUD]: '/images/icons/flags/aud.png',
  [Currency.USD]: '/images/icons/flags/usd.png',
  [Currency.NZD]: '/images/icons/flags/nzd.png',
  [Currency.SEK]: '/images/icons/flags/sek.png',
  [Currency.NOK]: '/images/icons/flags/nok.png',
  [Currency.GBP]: '/images/icons/flags/gbp.png',
  [Currency.CAD]: '/images/icons/flags/cad.png',
  [Currency.EUR]: '/images/icons/flags/eur.png',
};
